import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { EmployeeVisitOverlap } from 'src/api';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      message: String;
      status?: number;
      overlapDay?: string;
      employeeVisitOverlaps?: EmployeeVisitOverlap[];
    }
  ) {}

  ngOnInit() {
    if (this.data.employeeVisitOverlaps) {
      this.data.employeeVisitOverlaps.map((ev) => {
        ev.employeeName = ev.employeeName ? this.getAbbreviatedName(ev.employeeName) : '';
      });

      this.data.employeeVisitOverlaps = this.data.employeeVisitOverlaps.sort((a, b) =>
        a.employeeName!.toLowerCase().localeCompare(b.employeeName!.toLowerCase())
      );
    }
  }

  private getAbbreviatedName(name: string) {
    const nameArray = name.split(' ');
    let abbreviatedName: string = nameArray.length > 1 ? `${nameArray[0]} ${nameArray[1].charAt(0)}.` : nameArray[0];
    return abbreviatedName;
  }
}
